import Vue from 'vue'
import Router from 'vue-router'

const reservation = () =>
  import(/*  webpackChunkName: "reservation" */ './views/temporaryPark/reservation.vue')
const reservationold = () =>
  import(/* webpackChunkName: "reservationold" */ './views/temporaryPark/reservationold.vue')
const restaurantList = () =>
  import(/* webpackChunkName: "restaurantList" */ './views/smartRestaurant/restaurantList.vue')
const merchantList = () =>
  import(/* webpackChunkName: "merchantList" */ './views/smartRestaurant/merchantList.vue')
const storeDetail = () =>
  import(/* webpackChunkName: "storeDetail" */ './views/smartRestaurant/storeDetail.vue')
const orderList = () =>
  import(/* webpackChunkName: "orderList" */ './views/smartRestaurant/orderList.vue')
const orderDetail = () =>
  import(/* webpackChunkName: "orderDetail" */ './views/smartRestaurant/orderDetail.vue')
const checkout = () =>
  import(/* webpackChunkName: "checkout" */ './views/smartRestaurant/checkout.vue')
const orderRate = () =>
  import(/* webpackChunkName: "orderRate" */ './views/smartRestaurant/orderRate.vue')
const policyList = () =>
  import(/* webpackChunkName: "policyList" */ './views/smartRestaurant/policyList.vue')
const policyDetail = () =>
  import(/* webpackChunkName: "policyDetail" */ './views/smartRestaurant/policyDetail.vue')
const monthlyPark = () =>
  import(/* webpackChunkName: "monthlyPark" */ './views/monthlyPark/Index.vue')
const myScore = () => import(/* webpackChunkName: "myScore" */ './views/mine/myScore.vue')
const openInvoice = () =>
  import(/* webpackChunkName: "openInvoice" */ './views/invoice/openInvoice.vue')
const invoiceList = () =>
  import(/* webpackChunkName: "invoiceList" */ './views/invoice/invoiceList.vue')
const comtPro = () => import(/* webpackChunkName: "comtPro" */ './views/indexMore/comtPro.vue')
const fix = () => import(/* webpackChunkName: "fix" */ './views/indexMore/fix.vue')
const setNeeds = () => import(/* webpackChunkName: "setNeeds" */ './views/indexMore/setNeeds.vue')
const propertyList = () =>
  import(/* webpackChunkName: "propertyList" */ './views/property/list.vue')
const propertyDetail = () =>
  import(/* webpackChunkName: "propertyDetail" */ './views/property/detail.vue')
const chatGroup = () => import(/* webpackChunkName: "chatGroup" */ './views/chat/group.vue')

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/chatGroup',
      name: 'chatGroup',
      component: chatGroup,
      meta: {
        title: '社区交友'
      }
    },
    {
      path: '/openInvoice/id/:id/',
      name: 'openInvoice',
      component: openInvoice,
      meta: {
        title: '开票信息'
      }
    },
    {
      path: '/invoiceList',
      name: 'invoiceList',
      component: invoiceList,
      meta: {
        title: '我的发票'
      }
    },
    {
      path: '/myScore',
      name: 'myScore',
      component: myScore,
      meta: {
        title: '我的积分'
      }
    },
    {
      path: '/monthlyPark',
      name: 'monthlyPark',
      component: monthlyPark,
      meta: {
        title: '车位包月'
      }
    },
    {
      path: '/policyList',
      name: 'policyList',
      component: policyList,
      meta: {
        title: '办事指南'
      }
    },
    {
      path: '/policyDetail/id/:id',
      name: 'policyDetail',
      component: policyDetail,
      meta: {
        title: '办事指南'
      }
    },
    {
      path: '/temporaryPark/reservation/id/:id',
      name: 'reservation',
      component: reservation
    },
    {
      path: '/temporaryPark/reservationold/id/:id/no/:no',
      name: 'reservationold',
      component: reservationold
    },
    {
      path: '/restaurantList',
      name: 'restaurantList',
      component: restaurantList,
      meta: {
        title: '智慧食堂',
        keepAlive: true
      }
    },
    {
      path: '/merchantList',
      name: 'merchantList',
      component: merchantList,
      meta: {
        title: '周边',
        keepAlive: false
      }
    },
    {
      path: '/storeDetail/type/:type/meid/:meid',
      name: 'storeDetail',
      component: storeDetail,
      meta: {
        title: '加载中'
      }
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: orderList,
      meta: {
        title: '我的订单',
        keepAlive: true
      }
    },
    {
      path: '/orderDetail/orderid/:orderid',
      name: 'orderDetail',
      component: orderDetail,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/Checkout/type/:type/meid/:meid',
      name: 'checkout',
      component: checkout,
      meta: {
        title: '结算'
      }
    },
    {
      path: '/orderRate/orderid/:orderid',
      name: 'orderRate',
      component: orderRate,
      meta: {
        title: '评价'
      }
    },
    {
      path: '/comtPro',
      name: 'comtPro',
      component: comtPro,
      meta: {
        title: '投诉建议'
      }
    },
    {
      path: '/fix',
      name: 'fix',
      component: fix,
      meta: {
        title: '自助报修'
      }
    },
    {
      path: '/setNeeds',
      name: 'setNeeds',
      component: setNeeds,
      meta: {
        title: '发布需求'
      }
    },
    {
      path: '/propertyList',
      name: 'propertyList',
      component: propertyList,
      meta: {
        title: '物业服务'
      }
    },
    {
      path: '/propertyDetail/id/:id',
      name: 'propertyDetail',
      component: propertyDetail,
      meta: {
        title: '物业服务'
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      console.log(savedPosition)
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router.js